import { render, staticRenderFns } from "./FormPersonale.vue?vue&type=template&id=1ea6fcda&"
import script from "./FormPersonale.vue?vue&type=script&lang=js&"
export * from "./FormPersonale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports